<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
              <b-dropdown right no-caret variant="link" boundary="window" toggle-class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom title="Agregar oportunidad">
                <template #button-content><AppIcon name="add" label="Agregar oportunidad" /></template>
                <b-dropdown-header>Existentes</b-dropdown-header>
                <b-dropdown-item @click="addCustomer()"><AppIcon name="add" /> Clientes</b-dropdown-item>
                <b-dropdown-header>Nuevos</b-dropdown-header>
                <b-dropdown-item @click="addPerson()"><AppIcon name="add" /> Persona</b-dropdown-item>
                <b-dropdown-item @click="addCompany()"><AppIcon name="add" /> Empresa</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 240px;"><label class="filter-label">Nombre / Cliente</label><b-form-input v-model="filter.name" size="sm" type="text" @keyup.enter="filterQuery()" /></div>
            <div class="list-view-filter" style="width: 185px;"><label class="filter-label">Staff</label><v-select :options="arr.select.staff" v-model="filter.staff" :multiple="true" :select-on-tab="true" /></div>
            <div v-if="moduleSellersActive" class="list-view-filter" style="width: 185px;"><label class="filter-label">Vendedores</label><v-select :options="arr.select.sellers" v-model="filter.sellers" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="width: 145px;"><label class="filter-label">Tipo</label><v-select :options="arr.select.type" v-model="filter.type" :multiple="false" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="width: 175px;"><label class="filter-label">Etapa</label><v-select :options="arr.select.status" v-model="filter.status" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="width: 175px;"><label class="filter-label">Categoría</label><v-select :options="arr.select.categories" v-model="filter.categories" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="width: 175px;"><label class="filter-label">Origen</label><v-select :options="arr.select.sources" v-model="filter.sources" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="width: 195px;"><label class="filter-label">Motivo de pérdida</label><v-select :options="arr.select.lostMotives" v-model="filter.lostMotives" :multiple="true" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="width: 150px;"><label class="filter-label">Archivados</label><v-select :options="arr.select.archive" v-model="filter.archive" :multiple="false" :select-on-tab="true" /></div>
            <b-button variant="outline-dark" size="sm" @click="filterQuery()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>
      
      <b-tabs>
        <b-tab title="Lista" :active="tabs.list" @click="loadSalesFlowList()">

          <b-row class="mt-3">
            <b-col>
              <b-table class="app-table sales-flow-leads-services-table"
                      responsive
                      :stacked="isMobileViewport ? 'md' : false"
                      sticky-header="60vh"
                      :hover="true"
                      :fixed="true"
                      :items="formartedItems"
                      :fields="table.fields"
                      :busy="table.isBusy"
                      v-if="table.items.length || table.isBusy">

                  <template #table-busy><div class="text-center text-danger my-2"><b-spinner class="align-middle" /><strong> Cargando...</strong></div></template>

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>       

                  <template v-slot:cell(id)="data">
                    <b>{{ data.item.id }}</b>
                  </template>

                  <template v-slot:cell(date)="data"><div class="sales-flow-lead-date"><strong>{{ moment(data.item.date).format('DD MMMM') }}</strong><span>{{ moment(data.item.date).fromNow() }}</span></div></template>

                  <template v-slot:cell(history)="data"><b-button size="sm" variant="link" class="app-table-icon-btn sales-flow-lead-history-trigger" v-b-tooltip.hover title="Ver seguimientos" @click="openHistory(data.item)"><AppIcon name="chat" label="Ver seguimientos" /><b-badge pill variant="secondary">{{ data.item.history ? data.item.history.length : 0 }}</b-badge></b-button></template>

                  <template v-slot:cell(name)="data">
                    <div v-if="data.item.iscompany && data.item.customers_id" class="sales-flow-lead-identity" :class="'sales-flow-lead-identity--' + data.item.status">
                      <span class="crud-leads-table-title-company">Cliente</span> <br>
                      <span class="crud-leads-table-title-name">{{ data.item.customer.name }}</span> <br>                      
                      <div v-if="data.item.customer.data_fiscal && data.item.customer.data_fiscal.fiscal_condition">
                        <span class="crud-leads-table-title">Cond. Fiscal:</span> {{ data.item.customer.data_fiscal.fiscal_condition.name }} <br>
                      </div>
                      <div v-if="data.item.customer.data_fiscal && data.item.customer.data_fiscal.document_type">
                        <span class="crud-leads-table-title">{{ data.item.customer.data_fiscal.document_type.name }}:</span> {{ data.item.customer.data_fiscal.documents_number }} 
                      </div>
                    </div>                    
                    <div v-if="data.item.iscompany && !data.item.customers_id" class="sales-flow-lead-identity" :class="'sales-flow-lead-identity--' + data.item.status">
                      <span class="crud-leads-table-title-company">Empresa</span> <br>
                      <span class="crud-leads-table-title-name">{{ data.item.name }}</span> <br>
                      <div v-if="data.item.fiscal_condition">
                        <span class="crud-leads-table-title">Cond. Fiscal:</span> {{ data.item.fiscal_condition.name }} <br>
                      </div>
                      <div v-if="data.item.document_fiscal_type">
                        <span class="crud-leads-table-title">{{ data.item.document_fiscal_type.name }}:</span> {{ data.item.documents_fiscal_number }} 
                      </div>
                    </div>
                    <div v-if="!data.item.iscompany && !data.item.customers_id" class="sales-flow-lead-identity" :class="'sales-flow-lead-identity--' + data.item.status">
                      <span class="crud-leads-table-title-person">Persona</span> <br>
                      <span class="crud-leads-table-title-name">{{ data.item.name }} {{ data.item.last_name }}</span> <br>
                      <div v-if="data.item.document_type">
                        <span class="crud-leads-table-title">{{ data.item.document_type.name }}:</span> {{ data.item.documents_number }} <br>
                      </div>                    
                      <div v-if="data.item.document_fiscal_type">
                        <span class="crud-leads-table-title">{{ data.item.document_fiscal_type.name }}:</span> {{ data.item.documents_fiscal_number }} 
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(contact)="data">
                    <div class="sales-flow-lead-contact" v-if="data.item.email"><AppIcon name="mail" label="Email" /><a :href="'mailto:' + data.item.email">{{ data.item.email }}</a></div>
                    <div class="sales-flow-lead-contact" v-if="data.item.mobile"><AppIcon name="phone_iphone" label="Celular" /><a :href="'tel:' + data.item.mobile">{{ data.item.mobile }}</a></div>
                    <div class="sales-flow-lead-contact" v-if="data.item.work_phone"><AppIcon name="phone" label="Teléfono laboral" /><a :href="'tel:' + data.item.work_phone">{{ data.item.work_phone }}</a></div>
                    <div class="sales-flow-lead-contact" v-if="data.item.phone"><AppIcon name="phone" label="Teléfono particular" /><a :href="'tel:' + data.item.phone">{{ data.item.phone }}</a></div>

                    <div v-if="data.item.customers_id" class="mt-2">
                      <AppIcon name="people" />
                      <b-link href="javascript:void(0)" @click="openContactsCustomers(data.item)">                        
                        Ver Todos los Contactos
                      </b-link>
                    </div>                    
                  </template>

                  <template v-slot:cell(info)="data">
                    <div v-if="data.item.source" class="sales-flow-lead-info">
                      <span v-b-tooltip.hover title="Origen"><AppIcon name="alt_route" /></span>
                      <span>{{ data.item.source.name }}</span>
                    </div>
                    <div v-if="data.item.categories" class="sales-flow-lead-info">
                      <span v-b-tooltip.hover title="Categoría"><AppIcon name="category" /></span>
                      <span>{{ data.item.categories.name }}</span>
                    </div>                   
                  </template>
                          
                  <template v-slot:cell(status)="data"><div class="sales-flow-lead-status">
                    <div class="crud-leads-table-title-status" :class="'crud-leads-table-title-status--' + getStatusTable(data.item.status).code">
                      {{ getStatusTable(data.item.status).label }}
                    </div>

                    <div v-if="getStatusTable(data.item.status).code == 'lost'">
                      <div v-if="data.item.lost_motive" class="sales-flow-lead-status__reason">{{ data.item.lost_motive.name }}</div>
                    </div>
                    <div v-if="getStatusTable(data.item.status).code == 'won'">

                      <div v-if="data.item.external_approval">
                        Confirmación Externa                                             
                      </div>                  
                      <div v-if="data.item.firm">
                        <b-link :href="data.item.firm[0]" target="_blank">
                          Ver Firma
                          <AppIcon name="forward" />
                        </b-link>
                      </div>   
                      <div v-if="data.item.services_customers_id">
                        <b-link @click="goService()">Ver Servicio ID: {{data.item.services_customers_id}}</b-link>
                      </div>
                    </div>                  
                  </div></template>

                  <template v-slot:cell(responsable)="data">
                    <div v-if="data.item.staff_id" class="mb-1">
                      <span :title="'STAFF: ' + data.item.staff.name">
                        <b-avatar :src="data.item.staff.image"
                                  v-if="data.item.staff.image"
                                  size="sm">
                        </b-avatar>
                        <b-avatar v-else :text="avatarFromName(data.item.staff.name).text" :style="avatarFromName(data.item.staff.name).style" size="25px">
                        </b-avatar>                                             
                        <b>
                          {{data.item.staff.name}}
                        </b>                                          
                      </span>
                    </div>                  
                    <div v-if="data.item.sellers_id">     
                      <span :title="'VENDEDOR: ' + data.item.seller.staff.name">               
                        <b-avatar :src="data.item.seller.staff.image"
                                  v-if="data.item.seller.staff.image"
                                  size="sm">
                        </b-avatar>
                        <b-avatar v-else :text="avatarFromName(data.item.seller.staff.name).text" :style="avatarFromName(data.item.seller.staff.name).style" size="25px">
                        </b-avatar>                           
                        <b>
                          {{data.item.seller.staff.name}}
                        </b>  
                      </span>
                    </div>  
                  </template>

                  <template v-slot:cell(budget_id)="data">
                    <div v-if="data.item.budget" 
                        :title="data.item.budget.type_voucher.name + ' ' + data.item.budget.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.item.budget.number.toString().padStart(8,'0')" 
                        style="cursor:pointer;">
                      <span class="sales-flow-lead-budget"><AppIcon name="reports" :font-scale="1.25" /><br class="d-none d-md-block" /><b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.budget.currency.code, maximumFractionDigits: 0}).format(data.item.budget.amount_total)}}</b></span>
                    </div>        
                  </template>
                                            
                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right no-caret size="sm" variant="link" boundary="window"
                                :toggle-class="isMobileViewport ? 'sales-flow-leads-services-action-toggle-labeled' : 'app-table-action-toggle'"
                                :class="{ 'pull-right': !isMobileViewport }">
                      <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>

                      <b-dropdown-header v-if="data.item.budget">Impresión</b-dropdown-header>                      
                      <b-dropdown-item v-if="data.item.budget" @click="sendPrinterBudget(data.item.budget)">
                        <AppIcon name="print" /> Presupuesto
                      </b-dropdown-item>                                                   

                      <b-dropdown-header v-if="(data.item.status=='approval' && parameters.haveExternalApproval) || 
                                               (data.item.status=='won' && parameters.haveContract) ||
                                               (data.item.status=='won' && parameters.haveContract && parameters.haveExternalApproval)"> 
                        Proceso Adiccional
                      </b-dropdown-header>                      
                      <b-dropdown-item @click="externalApproval(data.item)" v-if="data.item.status=='approval' && parameters.haveExternalApproval">
                        <AppIcon name="external" /> Aprobación Externa
                      </b-dropdown-item>       
                      <b-dropdown-item @click="openContract(data.item)" v-if="data.item.status=='won' && parameters.haveContract">
                        <AppIcon name="print" /> Contrato
                      </b-dropdown-item>   
                      <b-dropdown-item @click="openChangeFirm(data.item)" v-if="data.item.status=='won' && parameters.haveContract && parameters.haveExternalApproval">
                        <AppIcon name="edit" /> Cambiar Firma
                      </b-dropdown-item>     

                      <b-dropdown-header v-if="data.item.status=='won' && parameters.createService">Servicio</b-dropdown-header>                      
                      <b-dropdown-item @click="createService(data.item)" v-if="data.item.status=='won' && parameters.createService && !data.item.services_customers_id">
                        <AppIcon name="add" /> Crear Servicio
                      </b-dropdown-item>     
                      <b-dropdown-item @click="unassignService(data.item)" v-if="data.item.status=='won' && parameters.createService && data.item.services_customers_id">
                        <AppIcon name="link_off" /> Desvincular Servicio
                      </b-dropdown-item>                                                                                             
                      
                      <b-dropdown-header>Estados</b-dropdown-header>
                      <b-dropdown-item @click="nextStage(data.item)" v-if="showNextStage(data.item)">
                        <AppIcon name="forward" /> Próxima Etapa
                      </b-dropdown-item>    
                      <b-dropdown-item @click="previousStage(data.item)" v-if="showPreviousStage(data.item)">
                        <AppIcon name="back" /> Etapa Anterior
                      </b-dropdown-item>                             

                      <b-dropdown-header>Archivado</b-dropdown-header>                                                            
                      <b-dropdown-item @click="archiveLead(data.item)" v-if="!data.item.archive">
                        <AppIcon name="archive" /> Archivar
                      </b-dropdown-item>                                      
                      <b-dropdown-item @click="archiveLead(data.item)" v-if="data.item.archive">
                        <AppIcon name="back" /> Restaurar
                      </b-dropdown-item>                                      

                      <b-dropdown-header>Acciones</b-dropdown-header>
                      <b-dropdown-item @click="edit(data.item)">
                        <AppIcon name="edit" /> Editar
                      </b-dropdown-item>
                      <b-dropdown-item @click="remove(data.item)">
                        <AppIcon name="delete" class="text-danger" /> Eliminar
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
              </b-table>
              <EmptyState v-else icon="reports" title="No se encontraron oportunidades" description="Ajustá los filtros o agregá una oportunidad nueva." />
              <div class="app-table-footer sales-flow-leads-services-table-footer"><span class="list-view-toolbar__count">{{ table.items.length }} oportunidades</span></div>
            </b-col>
          </b-row>                     
        </b-tab>

        <b-tab title="Kanban" :active="tabs.kanban" @click="loadSalesFlowKanban(true)">
          <kanban-board :stages="kanban.stages" :blocks="kanban.blocks" @update-block="updateBlock" :key="kanban.forceUpdate" class="sales-flow-kanban">
            <div v-for="stage in kanban.stages" :slot="stage" :key="stage" class="sales-flow-kanban-column-heading" :class="'sales-flow-kanban-column-heading--' + stage"><span>{{ getStatusName(stage) }}</span><b-badge pill>{{ getStatusCount(stage) }}</b-badge></div>

            <article v-for="block in kanban.blocks" :slot="block.id" :key="block.id" class="sales-flow-kanban-card" @dblclick="edit(block.data)" title="Doble click para editar">
              <header class="sales-flow-kanban-card__header"><span class="sales-flow-kanban-card__type">{{ block.data.iscompany && block.data.customers_id ? 'Cliente' : block.data.iscompany ? 'Empresa' : 'Persona' }}</span><span>{{ moment(block.data.created_at).fromNow() }}</span></header>
              <strong class="sales-flow-kanban-card__title">{{ leadDisplayName(block.data) }}</strong>
              <div class="sales-flow-kanban-card__tags"><span v-if="block.data.source"><AppIcon name="alt_route" /> {{ block.data.source.name }}</span><span v-if="block.data.categories"><AppIcon name="category" /> {{ block.data.categories.name }}</span></div>
              <div class="sales-flow-kanban-card__metrics"><b-button size="sm" variant="link" class="app-table-icon-btn sales-flow-lead-history-trigger" v-b-tooltip.hover title="Ver seguimientos" @click.stop="openHistory(block.data)"><AppIcon name="chat" label="Ver seguimientos" /><b-badge pill variant="secondary">{{ block.data.history ? block.data.history.length : 0 }}</b-badge></b-button><span v-if="block.data.budget"><AppIcon name="reports" /> {{ Intl.NumberFormat('es-AR',{style:'currency',currency: block.data.budget.currency.code, maximumFractionDigits: 0}).format(block.data.budget.amount_total) }}</span></div>
              <div class="sales-flow-kanban-card__people"><span v-if="block.data.staff_id"><b-avatar v-if="block.data.staff.image" :src="block.data.staff.image" size="25px" /><b-avatar v-else :text="avatarFromName(block.data.staff.name).text" :style="avatarFromName(block.data.staff.name).style" size="25px" /><span>{{ block.data.staff.name }}</span></span><span v-if="block.data.sellers_id"><b-avatar v-if="block.data.seller.staff.image" :src="block.data.seller.staff.image" size="25px" /><b-avatar v-else :text="avatarFromName(block.data.seller.staff.name).text" :style="avatarFromName(block.data.seller.staff.name).style" size="25px" /><span>{{ block.data.seller.staff.name }}</span></span></div>
              <footer class="sales-flow-kanban-card__footer"><span>{{ block.data.work_recurrent ? 'Servicio recurrente' : 'Proyecto' }}</span><span v-if="block.data.status == 'lost' && block.data.lost_motive">{{ block.data.lost_motive.name }}</span><b-button v-if="block.data.status=='won' && parameters.createService && block.data.services_customers_id" size="sm" variant="outline-secondary" @click.stop="goService()"><AppIcon name="visibility" class="mr-1" />Servicio</b-button><b-button v-if="block.data.status=='won' && parameters.createService && !block.data.services_customers_id" size="sm" variant="outline-secondary" @click.stop="createService(block.data)"><AppIcon name="add" class="mr-1" />Crear servicio</b-button><b-button v-if="block.data.status=='won' && parameters.createService && block.data.services_customers_id" size="sm" variant="outline-danger" @click.stop="unassignService(block.data)"><AppIcon name="link_off" class="mr-1" />Desvincular</b-button></footer>
            </article>
          </kanban-board>
        </b-tab>
      </b-tabs>      

      <b-card body-class="py-2" class="mt-2"><div class="list-view-footer"><b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)"><AppIcon name="back" class="mr-1" />Volver</b-button></div></b-card>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id" 
              :reference="crud.print.reference" 
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              :key="modal.form._id"
              :id="modal.form._id">    
                            
        <div slot="modal-header" minimize class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="edit" /></span><h5 class="app-modal-header__title">{{ modal.form.title }}</h5></div>

        <form-wizard class="crud-leads-services-wizard"
                     title=""
                     subtitle=""
                     nextButtonText="Siguiente"
                     backButtonText="Atrás"
                     finishButtonText="Guardar"
                     color="#2f353a"
                     shape="tab"
                     @on-complete="save">
            <tab-content title="Cliente" icon="fa fa-building" v-if="isCompany && isCustomer">
              <b-card-text>
                <b-row>
                  <b-col md="12">
                    <FindObject render="search"
                                type="customers" 
                                @select-object="loadCustomers($event)" 
                                :valueID="crud.form.customers_id"
                                :where="conditionCustomersActive"
                                description="Cargar el cliente de la oportunidad del negocio"/>           
                  </b-col>                  
                  <b-col md="6">
                    <b-form-group label="Categoría">
                      <v-select :options="arr.select.categories" v-model="crud.form.categories_id" placeholder="Categoría" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>   
                  </b-col> 
                  <b-col md="6">
                    <b-form-group label="Origen">
                      <v-select :options="arr.select.sources" v-model="crud.form.sources_id" placeholder="Origen" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>   
                  </b-col>
                </b-row>
              </b-card-text>
            </tab-content>

            <tab-content title="Persona" icon="fa fa-user" v-if="!isCompany && !isCustomer">
              <b-card-text>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Nombre">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.name">
                      </b-form-input>           
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Apellido">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.last_name">
                      </b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group label="Tipos de Documentos">
                      <v-select :options="arr.select.typesDocuments" v-model="crud.form.documents_types_id" placeholder="Tipos Documentos" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>
                  </b-col>   
                  <b-col md="6">
                    <b-form-group label="Número Documento">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.documents_number">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>  

                  <b-col md="6">
                    <b-form-group label="Tipos de Documentos Fiscales">
                      <v-select :options="arr.select.typesDocumentsFiscal" v-model="crud.form.documents_fiscal_types_id" placeholder="Tipos Documentos Fiscales" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>
                  </b-col>  
                  <b-col md="6">
                    <b-form-group label="Número Documento Fiscal">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.documents_fiscal_number">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col> 

                  <b-col md="6">
                    <b-form-group label="Categoría">
                      <v-select :options="arr.select.categories" v-model="crud.form.categories_id" placeholder="Categoría" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>   
                  </b-col> 
                  <b-col md="6">
                    <b-form-group label="Origen">
                      <v-select :options="arr.select.sources" v-model="crud.form.sources_id" placeholder="Origen" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>   
                  </b-col>

                  <b-col md="12">
                    <hr>
                  </b-col>

                  <b-col md="12">
                    <b-form-group label="Actividad Principal">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.main_activity">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col> 
                  <b-col md="12">
                    <b-form-group label="Observaciones">
                      <app-textarea                    
                        v-model="crud.form.observations"
                        size="md"
                        placeholder="Ingresar las observaciones..."
                        rows="3"
                        max-rows="6"
                      ></app-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-text>
            </tab-content>

            <tab-content title="Empresa" icon="fa fa-building" v-if="isCompany && !isCustomer">
              <b-card-text>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Razón Social">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.name">
                      </b-form-input>           
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Condición Fiscal">
                      <v-select :options="arr.select.fiscalConditions" v-model="crud.form.fiscal_conditions_id" placeholder="Condición Fiscal" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>
                  </b-col> 

                  <b-col md="6">
                    <b-form-group label="Tipos de Documentos Fiscales">
                      <v-select :options="arr.select.typesDocumentsFiscal" v-model="crud.form.documents_fiscal_types_id" placeholder="Tipos Documentos Fiscales" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>
                  </b-col>  
                  <b-col md="6">
                    <b-form-group label="Número Documento Fiscal">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.documents_fiscal_number">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col> 

                  <b-col md="6">
                    <b-form-group label="Categoría">
                      <v-select :options="arr.select.categories" v-model="crud.form.categories_id" placeholder="Categoría" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>   
                  </b-col> 
                  <b-col md="6">
                    <b-form-group label="Origen">
                      <v-select :options="arr.select.sources" v-model="crud.form.sources_id" placeholder="Origen" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                    </b-form-group>   
                  </b-col>

                  <b-col md="12">
                    <hr>
                  </b-col>

                  <b-col md="12">
                    <b-form-group label="Actividad Principal">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.main_activity">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col> 
                  <b-col md="12">
                    <b-form-group label="Observaciones">
                      <app-textarea                    
                        v-model="crud.form.observations"
                        size="md"
                        placeholder="Ingresar las observaciones..."
                        rows="3"
                        max-rows="6"
                      ></app-textarea>
                    </b-form-group>
                  </b-col>                                    
                </b-row>
              </b-card-text>
            </tab-content>

            <tab-content title="Ubicación" icon="fa fa-map-marker" v-if="!isCustomer">
              <b-card-text>
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Dirección">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.address">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>          
                  <b-col md="4">
                    <b-form-group label="Ciudad">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.city">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>      
                  <b-col md="2">
                    <b-form-group label="Código Postal">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.postal_code">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>  
                  <b-col md="6">
                    <b-form-group label="Provincia">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.state">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>  
                  <b-col md="6">
                    <b-form-group label="País">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.country">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>                    
                </b-row>             
              </b-card-text>
            </tab-content>
            
            <tab-content title="Contacto" icon="fa fa-address-book">
              <b-card-text>
                <b-row>     
                  <b-col md="6">
                    <b-form-group label="Contacto">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.contact">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>                   
                  <b-col md="6">
                    <b-form-group label="Email">
                      <b-form-input type="text"
                                    size="md"
                                    v-model="crud.form.email">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col> 

                  <b-col md="12">
                    <hr>
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Teléfono Particular">
                      <b-form-input type="number"                                    
                                    size="md"
                                    v-model="crud.form.phone">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col> 
                  <b-col md="4">
                    <b-form-group label="Teléfno Laboral/Comercial">
                      <b-form-input type="number"
                                    size="md"
                                    v-model="crud.form.work_phone">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>       
                  <b-col md="4">
                    <b-form-group label="Teléfono Celular" description="Ej: 5493416908870 (13 dígitos)">
                      <b-form-input type="number"
                                    size="md"
                                    v-model="crud.form.mobile">
                      </b-form-input>
                    </b-form-group>                    
                  </b-col>
                </b-row>
              </b-card-text>
            </tab-content>
            
            <tab-content title="Oportunidad" icon="fa fa-briefcase">
              <b-row>                
                <b-col md="12">
                  <b-form-checkbox v-model="crud.form.work_recurrent" 
                                    switch 
                                    size="sm"
                                    class="mt-2"
                                    @input="selectBudgets(crud.form.customers_id)">
                    Venta Recurrente
                  </b-form-checkbox>            
                </b-col>                          
                <b-col md="12" class="mt-3">
                  <b-form-group label="Necesidad">
                    <app-textarea                    
                      v-model="crud.form.work_budget"
                      size="md"
                      placeholder="Ingresar las descripción de la necesidad..."
                      rows="5"
                      max-rows="10"
                    ></app-textarea>
                  </b-form-group>
                </b-col>     
                <b-col md="12">
                  <b-form-checkbox v-model="crud.form.load_budget" 
                                    switch 
                                    size="sm"
                                    class="mt-2 mb-2">
                    Vincular un Presupuesto
                  </b-form-checkbox>            
                </b-col>                       
                <b-col md="12" v-if="crud.form.load_budget">
                  <b-form-group label="Presupuesto">
                    <v-select :options="arr.select.budgets" v-model="crud.form.budget_id" placeholder="Presupuestos" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
                  </b-form-group>
                </b-col>                   
              </b-row>
            </tab-content>
        </form-wizard>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CONTACTS CUSTOMERS-->
      <b-modal v-model="modal.contacts.active" size="md">
        <div slot="modal-header" class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="people" /></span><h5 class="app-modal-header__title">{{ modal.contacts.title }}</h5></div>
        
        <b-row v-if="modal.contacts.customer">
          <b-col md="12">
            <Contacts :customers="modal.contacts.customer" :customersID="modal.contacts.customer.id"></Contacts>
          </b-col>
        </b-row>                    
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.contacts.active = false">Cerrar</b-button>          
        </div>
      </b-modal>      
      
      <!-- HISTORY -->
      <b-sidebar v-model="modal.history.active" right shadow backdrop title="Seguimientos" width="480px" @hidden="historyItem = null">
        <div v-if="historyItem" class="list-view-drawer sales-flow-history-drawer">
            <div class="list-view-drawer__header">
            <div class="list-view-drawer__title"><span class="list-view-drawer__code">Oportunidad Nº {{ historyItem.id }}</span><div>{{ leadDisplayName(historyItem) }}</div></div>
            <div class="list-view-drawer__nav"><b-button size="sm" variant="outline-secondary" :disabled="!canGoHistoryPrev()" v-b-tooltip.hover title="Oportunidad anterior" @click="goHistoryPrev"><AppIcon name="chevron-up" /></b-button><b-button size="sm" variant="outline-secondary" :disabled="!canGoHistoryNext()" v-b-tooltip.hover title="Oportunidad siguiente" @click="goHistoryNext"><AppIcon name="chevron-down" /></b-button></div>
          </div>

          <div class="list-view-drawer__section-title"><AppIcon name="history" /> Seguimientos</div>
          <EmptyState v-if="!tableHistory.items.length" icon="history" title="Sin seguimientos" description="Agregá el primer comentario comercial." />
          <div v-else class="sales-flow-history-list">
            <article v-for="history in tableHistory.items" :key="history.id" class="sales-flow-history-entry">
              <b-avatar v-if="history.staff && history.staff.image" :src="history.staff.image" size="25px" />
              <b-avatar v-else-if="history.staff" :text="avatarFromName(history.staff.name).text" :style="avatarFromName(history.staff.name).style" size="25px" />
              <div class="sales-flow-history-entry__body"><div class="sales-flow-history-entry__meta"><strong>{{ history.staff ? history.staff.name : 'Sin responsable' }}</strong><span>{{ moment(history.date).fromNow() }}</span></div><div>{{ history.comment }}</div></div>
              <b-button size="sm" variant="link" class="app-table-icon-btn app-table-icon-btn--danger" v-b-tooltip.hover.left title="Eliminar comentario" @click="removeComment(history)"><AppIcon name="delete" label="Eliminar comentario" /></b-button>
            </article>
          </div>

          <div class="list-view-drawer__section-title"><AppIcon name="add" /> Nuevo seguimiento</div>
          <b-form-group label="Comentario"><app-textarea v-model="modal.history.comment" size="md" placeholder="Ingresar comentario del seguimiento comercial..." rows="3" max-rows="6" /></b-form-group>
          <b-button variant="outline-secondary" block @click="addCommentFromHistoryModal()" :disabled="!modal.history.comment || !modal.history.comment.trim()"><AppIcon name="add" class="mr-1" />Agregar comentario</b-button>
        </div>
      </b-sidebar>

      <!-- CRUD GANADO O PERDIDO -->
      <b-modal v-model="modal.stage.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="md">
        <div slot="modal-header" class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="tasks" /></span><h5 class="app-modal-header__title">{{ modal.stage.title }}</h5></div>
        
        <b-row>
          <b-col md="12">
            <b-form-group label="Resultado de la oportunidad" description="Seleccioná cómo finaliza esta oportunidad.">
              <b-button-group class="w-100">
                <b-button :variant="modal.stage.value == 'won' ? 'success' : 'outline-success'" @click="modal.stage.value='won'"><AppIcon name="thumb_up" class="mr-1" />Ganado</b-button>
                <b-button :variant="modal.stage.value == 'lost' ? 'danger' : 'outline-danger'" @click="modal.stage.value='lost'"><AppIcon name="thumb_down" class="mr-1" />Perdido</b-button>
              </b-button-group>
            </b-form-group>
          </b-col>

          <b-col md="12" v-if="modal.stage.value == 'won'">
            <b-alert show variant="success" class="mb-3"><AppIcon name="thumb_up" class="mr-1" />La oportunidad se marcará como ganada.</b-alert>
          </b-col>

          <b-col md="12" v-if="modal.stage.value == 'lost'">
            <b-alert show variant="danger" class="mb-3"><AppIcon name="thumb_down" class="mr-1" />La oportunidad se marcará como perdida.</b-alert>
          </b-col>
          <b-col md="12" v-if="modal.stage.value=='lost'">
            <b-form-group label="Motivo de Pérdida">
              <v-select :options="arr.select.lostMotives" v-model="crud.form.lost_motives_id" placeholder="Motivo de Pérdida" :multiple="false" :select-on-tab="true" class="crud-leads-select"></v-select>
            </b-form-group>                 
          </b-col>
          <b-col md="12" v-if="modal.stage.value=='won' || modal.stage.value=='lost'">
            <b-form-group label="Fecha de Estado">
              <b-form-input type="date" size="sm" v-model="modal.stage.date_status"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>                    
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="closeStageFinish()">Cancelar</b-button>
          <b-button variant="dark" :disabled="!modal.stage.value" @click="saveStageFinish()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal> 

      <!-- CONTRACT -->
      <b-modal v-model="modal.contract.active" size="xl">
        <div slot="modal-header" class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="print" /></span><h5 class="app-modal-header__title">{{ modal.contract.title }}</h5></div>
                
        <b-row>
          <b-col lg="12" v-if="modal.contract.leadObject">
            <h5>
              {{this.modal.contract.leadObject.name}}
              <b-badge v-if="modal.contract.leadObject.iscompany" variant="danger">Empresa</b-badge>
              <b-badge v-else variant="primary">Persona</b-badge>
            </h5>
          </b-col>

          <b-col lg="4">            
            <v-select :options="arr.select.contracts" 
                      v-model="modal.contract.contractObject" 
                      placeholder="Contratos" 
                      :multiple="false" 
                      :select-on-tab="true" 
                      class="crud-leads-select"
                      @change="showContract">
            </v-select>            
          </b-col>
          <b-col lg="8" v-if="modal.contract.urlPDF" class="crud-leads-preview-open-pdf">
            <strong>
              <b-link :href="modal.contract.urlPDF" target="_blank">
                Abrir PDF ({{this.modal.contract.contractObject.label}})
                <AppIcon name="forward" />
              </b-link>
            </strong>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col lg="12">      
            <div class="crud-leads-preview-contract">
              <div v-if="modal.contract.content" 
                  class="crud-leads-preview-contract-html" 
                  v-html="modal.contract.content">
              </div>
              <div v-else 
                  class="crud-leads-preview-contract-alert">
                <b-alert show variant="primary">Seleccion un formato de contrato</b-alert>
              </div>
            </div>
          </b-col>          
        </b-row>                    
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.contract.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="printContract()">Crear Contrato</b-button>          
        </div>
      </b-modal>

      <!-- FIRMA -->
      <b-modal v-model="modal.firm.active" size="sm">
        <div slot="modal-header" class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="edit" /></span><h5 class="app-modal-header__title">{{ modal.firm.title }}</h5></div>
                
        <b-row>
          <b-col lg="12">
            <b-form-group label="Firmar" 
                          description="Firme en una hoja en blanco y luego suba una foto de la misma (100px alto / 150px ancho)"
                          class="sales-flow-leads-label-custom">
              <Imagen :images="modal.firm.imagen" 
                      @load-image="modal.firm.imagen = $event" 
                      typeImage="Firma" 
                      class="sales-flow-leads-image"/>                        
            </b-form-group>            
          </b-col>         
        </b-row>
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.firm.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="changeFirm()">Cambiar Firma</b-button>          
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject'
  import Vue from 'vue'
  import Param from '@/config/parameters'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Imagen from '@/components/inc/image/image' 
  import Storage from '@/handler/storageLocal'  
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import vueKanban from 'vue-kanban'
  import Contacts from '@/components/modules/users/_access/customer/staff/contacts/crud'
  import Printer from '@/components/inc/printer/printer'

  Vue.use(vueKanban)

  export default {
    components: {
      FindObject,
      FormWizard,
      TabContent,
      Imagen,
      Contacts,
      Printer,
      TabHeaderActions,
    },      
    data: () => {
      return {      
        access: {
          module_id: Modules.FLUJO_VENTAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudLeadsServices',
          elements: {}
        }, 
        parameters: {                    
          haveExternalApproval: Helper.hasParametersAccess(Param.P6),
          haveContract: Helper.hasParametersAccess(Param.P16),
          createService: Helper.hasParametersAccess(Param.P23),
        },            
        table : {
          items: [],
          fields: [],          
          isBusy: false,
          currentPage: 1,
          perPage: 50,
        },   
        filtersOpen: false,
        isMobileViewport: false,
        historyItem: null,
        tableHistory: {
          items: [],
          fields: [            
            {key: 'date', label: 'Fecha', class: "align-middle", width:"10%"},
            {key: 'comment', label: 'Comentario', class: "align-middle", width:"70%"},
            {key: 'staff_id', label: 'Responsable', class: "align-middle", width:"15%"},            
            {key: 'f_action', label:'', class: "align-middle", width:"5%"}
          ],
        },         
        crud: {
          form: {
            id: 0,
            date: '',                                   
            name: '',
            last_name: '',
            address: '',
            city: '',
            postal_code: '',
            state: '',
            country: '',
            fiscal_conditions_id: 0,
            documents_types_id: 0,
            documents_number: '',
            documents_fiscal_types_id: 0,
            documents_fiscal_number: '',
            marital_status_id: 0,
            nationality: '',
            place_birth: '',
            birthday: null,
            gender: '',
            main_activity: '',
            phone: '',
            work_phone: '',
            mobile: '',
            email: '',
            status: '',
            address_correspondence: '',           
            registration_public_registry: null,
            year_end_date: null,
            registration_district: '',
            registration_number: '',
            registration_date: null,
            registration_book: '',
            registration_volume: '',
            registration_sheet: '',
            observations: '',        
            lost_motives_id: 0,
            categories_id: 0,
            sources_id: 0,
            staff_id: 0,
            staff: null,
            sellers_id: 0,  
            sellers: null,  
            iscompany: false,
            iscustomer: false,
            work_price: 0,
            work_budget: '',
            work_currency_id: 1,
            currency: null,
            work_recurrent: false,
            customers: null,
            customers_id: 0,
            contact: '',
            budget_id: 0,
            load_budget: true,
          },          
          formHistory: {
            leads_id: 0,
            comment: '',
          },
          print: {
            reference: 'budget',
            id: 0,
            key: 0,
          },                        
        },
        modal: {
          form: {
            active: false,
            title: ''
          },                
          stage: {
            active: false,
            title: '',
            value: '',
            id: 0,
            date_status: '',
          },
          contacts: {
            active: false,
            title: '',
            customer: null
          },     
          history: {
            active: false,
            title: '',
            leads_id: 0,
            comment: '',
          },                       
          contract: {
            active: false,
            title: '',
            contractObject: null,
            leadID: 0,
            content: '',
            urlPDF: '',
            leadObject: null,
          },
          firm: {
            active: false,
            title: '',
            image: [],
            leadID: 0,            
          }
        },
        arr: {
          select : {                        
            staff: [],
            sellers: [],
            gender: [],
            status: [],
            lostMotives: [],
            categories: [],
            sources: [],
            fiscalConditions: [],
            typesDocuments: [],
            typesDocumentsFiscal: [],
            maritalStatus: [],    
            type: [],
            contracts: [],  
            budgets: [],      
            archive: [],
          },
          leads: [],
          contracts: [],
        },
        filter: {                    
          staff: [],
          sellers: [],          
          name: '',
          type: [],
          categories: [],
          sources: [],
          status: [],
          lostMotives: [],
          archive: { code: false, label: "VISIBLES"},
        },        
        kanban: {
          stages: [],
          blocks: [],
          forceUpdate: 0.
        },
        tabs: {
          list: true,
          kanban: false,          
        }              
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {            
      this.setFieldTable()
      this.filtersOpen = Storage.getValue('filters_open_sales_flow_leads_services') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.selectLoad()
      this.filterLoad()
      this.filterQuery()

      this.restoreStatusTabsStorage()
    },
    beforeDestroy () { if (this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport) },
    computed: {
      // MODULES
      moduleSellersActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.VENDEDORES) {                             
            status = true                       
          }
        })        
        return status
      },

      formartedItems () {
        if (!this.table.items) return []
        return this.table.items.map(item => {
          return item
        })
      },
      isCompany () {
        if(this.crud.form.iscompany) {
          return true
        } else {
          return false
        }
      }, 
      isCustomer () {
        if(this.crud.form.iscustomer) {
          return true
        } else {
          return false
        }
      },
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
    },      
    watch: {        
      filtersOpen(value) { Storage.setValue('filters_open_sales_flow_leads_services', value ? 'true' : 'false') },
      isMobileViewport() { this.setFieldTable() },
      'arr.leads': function (newQuestion, oldQuestion) {        
        this.kanban.forceUpdate = this.kanban.forceUpdate + 1
        this.loadSalesFlowKanban()
      }
    }, 
    methods: {
      // CARGAR CAMPOS TABLA
      setFieldTable(){
        this.table.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + this.alignClass('text-left'), width:'50px'})
        this.table.fields.push({key: 'date', label: 'Fecha', class: 'align-middle ' + this.alignClass('text-left'), width:'100px'})
        this.table.fields.push({key: 'name', label: 'Nombre', class: 'align-middle ' + this.alignClass('text-left'), width:'250px'})
        this.table.fields.push({key: 'contact', label: 'Contacto', class: 'align-middle ' + this.alignClass('text-left'), width:'250px'})
        this.table.fields.push({key: 'info', label: 'Info', class: 'align-middle ' + this.alignClass('text-left'), width:'250px'})
        this.table.fields.push({key: 'history', label: this.isMobileViewport ? 'Seguimientos' : '', class: 'align-middle ' + this.alignClass('text-center'), width:'50px'})
        this.table.fields.push({key: 'responsable', label: 'Responsable', class: 'align-middle ' + this.alignClass('text-left'), width:'150px'})
        this.table.fields.push({key: 'status', label: 'Etapa', class: 'align-middle ' + this.alignClass('text-center'), width:'190px'})
        this.table.fields.push({key: 'budget_id', label: 'Presupuesto', class: 'align-middle ' + this.alignClass('text-center'), width:'80px'})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle ' + this.alignClass('text-right'), width:'100px'})
      },
      updateMobileViewport(event) { this.isMobileViewport = event.matches },
      alignClass(desktopClass) { return this.isMobileViewport ? 'text-left' : desktopClass },
      avatarFromName(name) { return Funciones.avatarFromName(name || '') },
      leadDisplayName(item) { return item.iscompany && item.customers_id ? item.customer.name : item.iscompany ? item.name : (item.name + ' ' + (item.last_name || '')).trim() },
      historyIndex() { return this.historyItem ? this.table.items.findIndex(item => item.id === this.historyItem.id) : -1 },
      canGoHistoryPrev() { return this.historyIndex() > 0 },
      canGoHistoryNext() { return this.historyIndex() >= 0 && this.historyIndex() < this.table.items.length - 1 },
      goHistoryPrev() { if(this.canGoHistoryPrev()) this.openHistory(this.table.items[this.historyIndex() - 1]) },
      goHistoryNext() { if(this.canGoHistoryNext()) this.openHistory(this.table.items[this.historyIndex() + 1]) },
      // CONFIG OPEN DETAIL TABLE
      getRowCount (items) {
        return items.length
      },
      onRowSelected(item) {              
        this.arr.leads.forEach((element, index) => {
          if(item.length){
            if(element.id == item[0].id) {
              this.openDetail(index)
            }
          }
        }) 
      },     
      openDetail(index) {                                
        this.table.rowSelected = index
        this.filterQuery()
      },        
      
      // FORM MAIN
      addCustomer() {
        this.crud.form.iscompany = true
        this.crud.form.iscustomer = true
        this.add()
      },
      addPerson() {        
        this.crud.form.iscompany = false
        this.crud.form.iscustomer = false

        this.selectBudgets()

        this.add()
      },
      addCompany() {
        this.crud.form.iscompany = true
        this.crud.form.iscustomer = false

        this.selectBudgets()

        this.add()
      },
      add() {        
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')                                  
        this.crud.form.name = ''
        this.crud.form.last_name = ''
        this.crud.form.address = ''
        this.crud.form.city = ''
        this.crud.form.postal_code = ''
        this.crud.form.state = ''
        this.crud.form.country = ''
        this.crud.form.fiscal_conditions_id = null
        this.crud.form.documents_types_id = null
        this.crud.form.documents_number = ''
        this.crud.form.documents_fiscal_types_id = null
        this.crud.form.documents_fiscal_number = ''
        this.crud.form.marital_status_id = null
        this.crud.form.nationality = ''
        this.crud.form.place_birth = ''
        this.crud.form.birthday = null
        this.crud.form.gender = ''
        this.crud.form.main_activity = ''
        this.crud.form.phone = ''
        this.crud.form.work_phone = ''
        this.crud.form.mobile = ''
        this.crud.form.email = ''
        this.crud.form.status = ''
        this.crud.form.address_correspondence = ''    
        this.crud.form.registration_public_registry = null
        this.crud.form.year_end_date = null
        this.crud.form.registration_district = ''
        this.crud.form.registration_number = ''
        this.crud.form.registration_date = null
        this.crud.form.registration_book = ''
        this.crud.form.registration_volume = ''
        this.crud.form.registration_sheet = ''
        this.crud.form.observations = ''    
        this.crud.form.lost_motives_id = null
        this.crud.form.categories_id = null
        this.crud.form.sources_id = null

        this.crud.form.staff_id = Helper.getStaffId()        
        this.crud.form.sellers_id = null
        this.crud.form.customers_id = null
        
        this.crud.form.work_price = 0
        this.crud.form.work_budget = ''
        this.crud.form.work_currency_id = 1
        this.crud.form.work_recurrent = false

        this.crud.form.contact = ''
        this.crud.form.budget_id = null   
        this.crud.form.load_budget = true

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Oportunidad"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.iscompany = item.iscompany
        this.crud.form.iscustomer = item.customers_id ? true : false

        this.crud.form.id = item.id      
        this.crud.form.date = item.date
        this.crud.form.name = item.name
        this.crud.form.last_name = item.last_name
        this.crud.form.address = item.address
        this.crud.form.city = item.city
        this.crud.form.postal_code = item.postal_code
        this.crud.form.state = item.state
        this.crud.form.country = item.country
        
        if(item.marital_status) {
          this.crud.form.marital_status_id = { code: item.marital_status.id, label: item.marital_status.name }
        } else {
          this.crud.form.marital_status_id = null
        }

        if(item.fiscal_condition) {
          this.crud.form.fiscal_conditions_id = { code: item.fiscal_condition.id, label: item.fiscal_condition.name }
        } else {
          this.crud.form.fiscal_conditions_id = null
        }
        
        if(item.document_type) {
          this.crud.form.documents_types_id = { code: item.document_type.id, label: item.document_type.name } 
        } else {
          this.crud.form.documents_types_id = null
        }                

        if(item.document_fiscal_type) {
          this.crud.form.documents_fiscal_types_id = { code: item.document_fiscal_type.id, label: item.document_fiscal_type.name }
        } else {
          this.crud.form.documents_fiscal_types_id = null
        }
                
        this.crud.form.documents_number = item.documents_number
        this.crud.form.documents_fiscal_number = item.documents_fiscal_number 
        this.crud.form.nationality = item.nationality
        this.crud.form.place_birth = item.place_birth
        this.crud.form.birthday = item.birthday
        this.crud.form.gender = this.getGenderSelect(item.gender)
        this.crud.form.main_activity = item.main_activity
        this.crud.form.phone = item.phone
        this.crud.form.work_phone = item.work_phone
        this.crud.form.mobile = item.mobile
        this.crud.form.email = item.email
        this.crud.form.status = this.getStatusSelect(item.status)
        this.crud.form.address_correspondence = item.address_correspondence    
        this.crud.form.registration_public_registry = item.registration_public_registry
        this.crud.form.year_end_date = item.year_end_date
        this.crud.form.registration_district = item.registration_district
        this.crud.form.registration_number = item.registration_number
        this.crud.form.registration_date = item.registration_date
        this.crud.form.registration_book = item.registration_book
        this.crud.form.registration_volume = item.registration_volume
        this.crud.form.registration_sheet = item.registration_sheet
        this.crud.form.observations = item.observations 

        if(item.lost_motive) {
          this.crud.form.lost_motives_id = { code: item.lost_motive.id, label: item.lost_motive.name }          
        } else {
          this.crud.form.lost_motives_id = null
        }

        if(item.categories) {
          this.crud.form.categories_id = { code: item.categories.id, label: item.categories.name }           
        } else {
          this.crud.form.categories_id = null
        }

        if(item.source) {
          this.crud.form.sources_id = { code: item.source.id, label: item.source.name }
        } else {
          this.crud.form.sources_id = null
        }               
        
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id    
        this.crud.form.customers_id = item.customers_id

        this.crud.form.work_price = item.work_price
        this.crud.form.work_budget = item.work_budget
        this.crud.form.work_currency_id = item.work_currency_id
        this.crud.form.work_recurrent = item.work_recurrent

        this.crud.form.contact = item.contact

        if(!item.customers_id) {
          if(item.budget) {
            this.selectBudgets(null, item.budget)
          } else {
            this.selectBudgets()
          }
        } else {
          if(item.budget) {
            this.selectBudgets(item.customers_id, item.budget)
          }
        }

        this.crud.form.load_budget = item.load_budget
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Oportunidad"
        this.modal.form.active = true
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - ('+ this.crud.form.name + ')?', { title: 'Borrar oportunidad', icon: 'delete', danger: true, okTitle: 'Sí', cancelTitle: 'No' })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarLeads(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.filterQuery()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        if(this.crud.form.mobile && !Funciones.validarTelefonoWhatsapp(this.crud.form.mobile)) {
          this.$awn.alert("El Teléfono Celular no posee un formato válido para Whatsapp (cod país [sin el signo] + nueve [9] + cod área [sin el 0] + nro cel [sin el 15], total 13 dígitos)");
          return false
        }

        this.confirmDialog('¿Desea continuar con la operación?', { title: 'Guardar oportunidad', okTitle: 'Aceptar' })
        .then(value => {
          if (value) {      
            let loader = this.$loading.show();                      
            
            var customFiscalConditions = this.crud.form.fiscal_conditions_id
            var customDocumentsTypes = this.crud.form.documents_types_id
            var customDocumentsFiscalTypes = this.crud.form.documents_fiscal_types_id
            var customMaritalStatus = this.crud.form.marital_status_id
            var customLostMotives = this.crud.form.lost_motives_id
            var customCategories = this.crud.form.categories_id
            var customSources = this.crud.form.sources_id            
            var customBudget = this.crud.form.budget_id            
            var customGender = this.crud.form.gender
            var customStatus = this.crud.form.status
                        
            this.crud.form.fiscal_conditions_id = this.crud.form.fiscal_conditions_id ? this.crud.form.fiscal_conditions_id.code : null
            this.crud.form.documents_types_id = this.crud.form.documents_types_id ? this.crud.form.documents_types_id.code : null
            this.crud.form.documents_fiscal_types_id = this.crud.form.documents_fiscal_types_id ? this.crud.form.documents_fiscal_types_id.code : null
            this.crud.form.marital_status_id = this.crud.form.marital_status_id ? this.crud.form.marital_status_id.code : null
            this.crud.form.lost_motives_id = this.crud.form.lost_motives_id ? this.crud.form.lost_motives_id.code : null
            this.crud.form.categories_id = this.crud.form.categories_id ? this.crud.form.categories_id.code : null
            this.crud.form.sources_id = this.crud.form.sources_id ? this.crud.form.sources_id.code : null               
            this.crud.form.budget_id = this.crud.form.budget_id ? this.crud.form.budget_id.code : null
            
            if(this.crud.form.gender) {
              this.crud.form.gender = this.crud.form.gender.code
            } else {
              this.crud.form.gender = null
            }
            
            if(this.crud.form.status) {
              this.crud.form.status = this.crud.form.status.code
            } else {
              this.crud.form.status = null
            }

            if (this.crud.form.id) {
              var result = serviceAPI.editarLeads(this.crud.form);
            } else {
              var result = serviceAPI.agregarLeads(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterQuery()
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {              
              this.crud.form.fiscal_conditions_id = customFiscalConditions
              this.crud.form.documents_types_id = customDocumentsTypes
              this.crud.form.documents_fiscal_types_id = customDocumentsFiscalTypes
              this.crud.form.marital_status_id = customMaritalStatus
              this.crud.form.lost_motives_id = customLostMotives
              this.crud.form.categories_id = customCategories
              this.crud.form.sources_id = customSources
              this.crud.form.budget_id = customBudget
              this.crud.form.gender = customGender
              this.crud.form.status = customStatus
              
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })               
      },   

      // FILTER
      filterLoad() {                
        this.filterLoadStaff()     
        this.filterLoadSellers()           
        this.filterLoadType()
        this.filterLoadArchive()
                
        this.restoreFilterStorage() 
      },
      filterLoadStaff() {
        var result = serviceAPI.obtenerStaff()        
        result.then((response) => {
          var data = response.data    

          this.arr.select.staff = []
          data.forEach(element => {                            
            if(!element.seller) {             
              this.arr.select.staff.push({ code: element.id, label: element.name })    
            }                    
          });          
        })   
      },
      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedores()        
        result.then((response) => {
          var data = response.data    

          this.arr.select.sellers = []
          data.forEach(element => {                            
            this.arr.select.sellers.push({ code: element.id, label: element.name })            
          });          
        })   
      },    
      filterLoadType() {
        this.arr.select.type = []        
        this.arr.select.type.push({ code: 'customer', label: 'Cliente' })                        
        this.arr.select.type.push({ code: 'person', label: 'Persona' })                        
        this.arr.select.type.push({ code: 'company', label: 'Empresa' })                                
      },
      filterLoadArchive() {
        this.arr.select.archive = []        
        this.arr.select.archive.push({ code: false, label: 'VISIBLES' })                        
        this.arr.select.archive.push({ code: true, label: 'ARCHIVADOS' })                                
      },
      filterQuery(){
        let loader = this.$loading.show()   
        this.table.isBusy = true
   
        var result = serviceAPI.filtrarLeads(this.filter)        
        result.then((response) => {
          loader.hide()
          this.table.isBusy = false

          var data = response.data
          this.table.items = data
          this.arr.leads = data
          
          if(this.table.rowSelected!=null) {
            this.table.items[this.table.rowSelected]._showDetails = true                                        
          } 
          
          this.saveFilterStorage()
        })
        .catch(error => {
          loader.hide()                    
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error))          
        });          
      }, 

      // SELECT CONTROLS
      selectLoad(){
        this.selectGender()     
        this.selectStatus() 
        this.selectLostMotives()
        this.selectCategories()
        this.selectSources()
        this.selectFiscalConditions()
        this.selectTypesDocuments()
        this.selectTypesDocumentsFiscal()
        this.selectMaritalStatus()
        this.selectContracts()        
      },
      selectGender(){
        this.arr.select.gender = []        
        this.arr.select.gender.push({ code: 'male', label: 'Masculino' })                        
        this.arr.select.gender.push({ code: 'female', label: 'Femenino' })                        
        this.arr.select.gender.push({ code: 'others', label: 'Otros' })      
      },
      selectStatus(){        
        this.arr.select.status = []        
        this.arr.select.status.push({ code: 'interested', label: 'Oportunidad' })                        
        this.arr.select.status.push({ code: 'in process', label: 'Relevamiento' })                        
        this.arr.select.status.push({ code: 'approval', label: 'Presupuesto' })                        
        this.arr.select.status.push({ code: 'won', label: 'Ganado' })                        
        this.arr.select.status.push({ code: 'lost', label: 'Perdido' })                        
      },
      selectLostMotives(){
        var result = serviceAPI.obtenerLeadsLostMotive()        
        result.then((response) => {
          var data = response.data
          data = data.sort((a, b) => (a.name || '').localeCompare((b.name || ''), 'es', { sensitivity: 'base' }))

          this.arr.select.lostMotives = []
          data.forEach(element => {                                                  
            this.arr.select.lostMotives.push({ code: element.id, label: element.name })                
          });          
        })  
      },  
      selectCategories(){
        var result = serviceAPI.obtenerLeadsCategories()        
        result.then((response) => {
          var data = response.data
          data = data.sort((a, b) => (a.name || '').localeCompare((b.name || ''), 'es', { sensitivity: 'base' }))

          this.arr.select.categories = []
          data.forEach(element => {                                                  
            this.arr.select.categories.push({ code: element.id, label: element.name })                
          });          
        })  
      },  
      selectSources(){
        var result = serviceAPI.obtenerLeadsSources()        
        result.then((response) => {
          var data = response.data
          data = data.sort((a, b) => (a.name || '').localeCompare((b.name || ''), 'es', { sensitivity: 'base' }))

          this.arr.select.sources = []
          data.forEach(element => {                                                  
            this.arr.select.sources.push({ code: element.id, label: element.name })                
          });          
        })  
      },  
      selectFiscalConditions(){
        var result = serviceAPI.obtenerLeadsFiscalConditions()        
        result.then((response) => {
          var data = response.data    

          this.arr.select.fiscalConditions = []
          data.forEach(element => {                                                  
            this.arr.select.fiscalConditions.push({ code: element.id, label: element.name })                
          });          
        })  
      },  
      selectTypesDocuments(){
        var result = serviceAPI.obtenerLeadsTypesDocuments()        
        result.then((response) => {
          var data = response.data    

          this.arr.select.typesDocuments = []
          data.forEach(element => {                                                  
            this.arr.select.typesDocuments.push({ code: element.id, label: element.name })                
          });          
        })  
      },  
      selectTypesDocumentsFiscal(){
        var result = serviceAPI.obtenerLeadsTypesDocumentsFiscal()        
        result.then((response) => {
          var data = response.data    

          this.arr.select.typesDocumentsFiscal = []
          data.forEach(element => {                                                  
            this.arr.select.typesDocumentsFiscal.push({ code: element.id, label: element.name })                
          });          
        })  
      },  
      selectMaritalStatus(){
        var result = serviceAPI.obtenerLeadsMaritalStatus()        
        result.then((response) => {
          var data = response.data    

          this.arr.select.maritalStatus = []
          data.forEach(element => {                                                  
            this.arr.select.maritalStatus.push({ code: element.id, label: element.name })                
          });          
        })  
      },  
      selectContracts() {
        var result = serviceAPI.obtenerContrato()        
        result.then((response) => {
          var data = response.data    

          this.arr.select.contracts = []
          data.forEach(element => {                                                  
            this.arr.select.contracts.push({ code: element.id, label: element.name })                
            this.arr.contracts.push(element)                
          });          
        })  
      },
      selectBudgets(customers_id=null, budget=null) {
        var params = {
          status: [{code: "open"}],          
          recurrent: {code: this.crud.form.work_recurrent},          
        }

        if(customers_id) {          
          params.customers = [{code: customers_id}]
        }

        var result = serviceAPI.filtrarPresupuesto(params)        
        result.then((response) => {
          var data = response.data.data

          this.arr.select.budgets = []
          data.forEach(element => {                       
            let label = moment(element.date).format('DD/MM/YYYY') + ' | ' +
                        element.customer.name + ' | ' + 
                        element.type_voucher.name + ' ' + 
                        element.point_sale.point_sale.toString().padStart(4,'0') + '-' + 
                        element.number.toString().padStart(8,'0') + ' | ' +
                        Intl.NumberFormat('es-AR',{style:'currency',currency: element.currency.code, maximumFractionDigits: 0}).format(element.amount_total) + ' | ' +
                        (element.recurrent ? 'Servicio Recurrente' : 'Proyecto Único')

            this.arr.select.budgets.push({ code: element.id, label: label })                              
          });    
          
          if(budget) {
            console.log(budget)
            let label = moment(budget.date).format('DD/MM/YYYY') + ' | ' +
                        budget.customer.name + ' | ' + 
                        budget.type_voucher.name + ' ' + 
                        budget.point_sale.point_sale.toString().padStart(4,'0') + '-' + 
                        budget.number.toString().padStart(8,'0') + ' | ' +
                        Intl.NumberFormat('es-AR',{style:'currency',currency: budget.currency.code, maximumFractionDigits: 0}).format(budget.amount_total) + ' | ' +
                        (budget.recurrent ? 'Servicio Recurrente' : 'Proyecto Único')
            
            setTimeout(() => {
              this.crud.form.budget_id = { code: budget.id, label: label }                             
            }, 1000);            
          } else {
            this.crud.form.budget_id = null
          }
        }) 
      },

      // LOAD CONTROL 
      loadCurrency (object) {
        if(object){
          this.crud.form.work_currency = object
          this.crud.form.work_currency_id = object.id
        } else {
          this.crud.form.work_currency = null
          this.crud.form.work_currency_id = 0
        }
      },        
      loadCustomers (object) {        
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id    
                    
          this.selectBudgets(object.id)
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = null
        }
      },  
      loadSellers (object) {        
        if(object){
          this.crud.form.sellers = object
          this.crud.form.sellers_id = object.id        
        } else {
          this.crud.form.sellers = null
          this.crud.form.sellers_id = null
        }
      },  
      loadStaff (object) {        
        if(object){
          this.crud.form.staff = object
          this.crud.form.staff_id = object.id        
        } else {
          this.crud.form.staff = null
          this.crud.form.staff_id = null
        }
      },                   

      // GETTERS
      getGenderSelect(value) {
        var result = null
        this.arr.select.gender.forEach(element=>{
          if(element.code==value) {
            result = element
          }
        })
        return result
      },
      getStatusSelect(value) {
        var result = null
        this.arr.select.status.forEach(element=>{
          if(element.code==value) {
            result = element
          }
        })
        return result
      },  
      getStatusName(value) {
        var name = ''
        this.arr.select.status.forEach(element=>{
          if(element.code==value) {
            name = element.label
          }
        })
        return name
      },
      getTotalByStatus(value) {
        var count = 0
        this.arr.leads.forEach(element=>{
          if(value == element.status) {
            count++ 
          }         
        })
        
        var msj = "Items"
        if(count <= 1) {
          msj = "Item"
        }
        return '<b>' + Intl.NumberFormat('es-AR',{ maximumFractionDigits: 0 }).format(count) + ' ' + msj + '</b>'        
      },
      getStatusCount(value) { return this.arr.leads.filter(item => item.status == value).length },
      getStatusTable(value) {
        var result = null
        this.arr.select.status.forEach(element=>{
          if(element.code==value) {
            result = {
              code: element.code,
              label: element.label,
            }
          }
        })
        return result
      }, 

      goService() {
        this.$router.push({ name: 'ServicesStaffCrudServicesCustomers'}) 
      },      
      externalApproval(item){ 
        let loader = this.$loading.show();
        var result = serviceAPI.enviarNotificationExternalApproval({
          id: item.id
        });

        result.then((response) => {              
          loader.hide()          
          this.$awn.success("Notificación enviada por email");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
        //this.$router.push({ name: 'SalesFlowPublicApproval', params: {leadsID: item.id} })
      },

      // FUNCTIONS --> CONTRACT
      openContract(item) {
        this.modal.contract.content = ''
        this.modal.contract.urlPDF = ''
        this.modal.contract.contractObject = null
        this.modal.contract.leadID = item.id      
        this.modal.contract.leadObject = item

        this.modal.contract.title = "Contrato"
        this.modal.contract.active = true        
      },
      showContract(item) {
        this.modal.contract.urlPDF = ''        
        this.modal.contract.content = ''        
        if(item) {                  
          this.arr.contracts.forEach(element => {            
            if(element.id == item.code) {
              this.modal.contract.content = element.content              
            }
          });
        }      
      },
      printContract() {
        if(!this.modal.contract.content) {
          this.$awn.alert("Seleccione un tipo de contrato")
          return false
        }

        let loader = this.$loading.show()
        this.modal.contract.urlPDF = ''

        var result = serviceAPI.crearContrato({
          contractID: this.modal.contract.contractObject.code,
          leadID: this.modal.contract.leadID,
        })        
        result.then((response) => {        
          var data = response.data              
          this.modal.contract.urlPDF = data
          loader.hide()          
        })     
        .catch(error => {
          loader.hide()                    
          this.$awn.alert(Error.showError(error))
        });                                
      },

      // FUNCTIONS --> FIRM
      openChangeFirm(item) {
        this.modal.firm.leadID = item.id
        if(item.firm.length>0) {
          this.modal.firm.imagen = [{ path: item.firm }]
        } else {
          this.modal.firm.imagen = []
        }

        this.modal.firm.title = "Firma"
        this.modal.firm.active = true       
      },
      changeFirm(){
        let loader = this.$loading.show();

        var image = new FormData();
        this.modal.firm.imagen.forEach((value, key) => {
          image.append(key, value.path);
        })
                
        var result = serviceAPI.changeFirmLeads(JSON.stringify({
          leadID: this.modal.firm.leadID,
          image: 0
        }), image);        

        result.then((response) => {          
          this.modal.firm.active = false
          loader.hide()
          this.filterQuery()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },

      // FUNCTIONS --> SERVICES
      createService(item) {
        this.confirmDialog('¿Desea crear el servicio?', { title: 'Crear servicio', icon: 'add', okTitle: 'Aceptar' })
        .then(value => {
          if (value) {              
            let loader = this.$loading.show();
            var result = serviceAPI.createServices(item);

            result.then((response) => {              
              loader.hide()   
              this.filterQuery()       
              this.$awn.success("Servicio Creado y Vinculado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })        
            //this.$router.push({ name: 'SalesFlowPublicApproval', params: {leadsID: item.id} })        
          }
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })                              
      },
      unassignService(item) {
        this.confirmDialog('¿Desea desvincular el servicio?', { title: 'Desvincular servicio', icon: 'link_off', danger: true, okTitle: 'Aceptar' })
        .then(value => {
          if (value) {          
            let loader = this.$loading.show();
            var result = serviceAPI.unassignService(item);

            result.then((response) => {              
              loader.hide()    
              this.filterQuery()      
              this.$awn.success("Servicio Desvinculado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })        
            //this.$router.push({ name: 'SalesFlowPublicApproval', params: {leadsID: item.id} })                
          }
        })
        .catch(error => {          
          this.$awn.alert(Error.showError(error));
        })              
      },

      // STATUS
      getStageDefaultDate() {
        return moment().format('YYYY-MM-DD')
      },
      nextStage(item){                
        if(item.status == 'approval') {             
          this.crud.form.lost_motives_id = null
          this.modal.stage.value = ''
          this.modal.stage.id = item.id
          this.modal.stage.date_status = item.date_status ? item.date_status : this.getStageDefaultDate()

          this.modal.stage.title = "Etapa Final"
          this.modal.stage.active = true
        } else {
          let loader = this.$loading.show();     

          var data = {
            id: item.id,   
            status: this.setNextStage(item.status)
          }                         
          var result = serviceAPI.setStatusLeads(data);        

          result.then((response) => {          
            loader.hide()
            this.filterQuery()
            this.$awn.success("Datos guardados con éxito");
          })
          .catch(error => {                        
            loader.hide()
            this.$awn.alert(Error.showError(error));
          })
        }
      },
      showNextStage(item){      
        if(item.status == 'won' || item.status == 'lost') {
          return false
        } else {
          return true
        }
      },
      previousStage(item){
        let loader = this.$loading.show();     
        var data = {
          id: item.id,    
          status: this.setPreviousStage(item.status)      
        }                         
        var result = serviceAPI.setStatusLeads(data);        

        result.then((response) => {          
          loader.hide()
          this.filterQuery()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {                        
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },  
      showPreviousStage(item){
        if(item.status == 'interested') {
          return false
        } else {
          return true
        }
      },
      setNextStage(value) {
        var nextStage = ''
        if(value == 'interested') {
          nextStage = 'in process'
        }
        
        if(value == 'in process') {
          nextStage = 'approval'
        }
        return nextStage
      },
      setPreviousStage(value) {
        var nextStage = ''
        if(value == 'won' || value == 'lost') {
          nextStage = 'approval'
        }
        
        if(value == 'approval') {
          nextStage = 'in process'
        }

        if(value == 'in process') {
          nextStage = 'interested'
        }
        return nextStage
      },
      saveStageFinish() {
        let loader = this.$loading.show();     

        var data = {
          id: this.modal.stage.id,   
          status: this.modal.stage.value,
          lostMotive: this.crud.form.lost_motives_id ? this.crud.form.lost_motives_id.code : null,
          date_status: this.modal.stage.date_status ? this.modal.stage.date_status : this.getStageDefaultDate()
        }                         
        var result = serviceAPI.setStatusLeads(data);        

        result.then((response) => {  
          this.modal.stage.active = false        
          loader.hide()
          this.filterQuery()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {                        
          this.modal.stage.active = false
          loader.hide()
          this.$awn.alert(Error.showError(error));

          this.kanban.forceUpdate = this.kanban.forceUpdate + 1
          this.loadSalesFlowKanban()   
        })
      },
      closeStageFinish() {
        this.modal.stage.active=false
        this.modal.stage.date_status = this.getStageDefaultDate()

        this.kanban.forceUpdate = this.kanban.forceUpdate + 1
        this.loadSalesFlowKanban()       
      },
      validStatusAction(item, newStatus) {
        var action = ''
        if(item.status == 'interested') {
          if(newStatus == 'in process') {
            action = 'next'
          }                  
        } 
        
        if(item.status == 'in process') {
          if(newStatus == 'approval') {
            action = 'next'
          } 
          if (newStatus == 'interested') {
            action = 'prev'
          }
          if(newStatus == 'lost') {
            action = 'next'
          }                    
        } 
        
        if(item.status == 'approval') {
          if(newStatus == 'won' || newStatus == 'lost') {
            action = 'next'
          } 
          if (newStatus == 'in process') {
            action = 'prev'
          }
          if(newStatus == 'lost') {
            action = 'next'
          }                    
        } 
        
        if(item.status == 'won') {
          if(newStatus == 'approval') {
            action = 'prev'
          }
        } 
        
        if(item.status == 'lost') {
          if(newStatus == 'approval') {
            action = 'prev'
          }
        }         
        return action
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_sales_flow_leads', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_sales_flow_leads')) {
          let data = JSON.parse(Storage.getValue('filter_sales_flow_leads'))
          this.filter = Object.assign({}, this.filter, data)
          if(!this.filter.archive) {
            this.filter.archive = { code: false, label: "VISIBLES" }
          }
        }         
      },  
      saveStatusTabsStorage() {
        Storage.setValue('tabs_view_sales_flow', JSON.stringify(this.tabs))
      },
      restoreStatusTabsStorage() {
        if(Storage.getValue('tabs_view_sales_flow')) {
          this.tabs = JSON.parse(Storage.getValue('tabs_view_sales_flow'))
        }         
      },        
      
      // LOAD TABS
      disableAllTabs() {
        this.tabs.list = false
        this.tabs.kanban = false
      },      
      loadSalesFlowList() {
        this.disableAllTabs()
        this.tabs.list = true
        this.saveStatusTabsStorage()  
      },
      loadSalesFlowKanban(forceSaveTabs=false) {
        if(forceSaveTabs) {
          this.disableAllTabs()
          this.tabs.kanban = true
          this.saveStatusTabsStorage()
        }

        this.kanban.stages = []
        if(this.arr.select.status) {
          this.arr.select.status.forEach(element => {
            this.kanban.stages.push(element.code)
          });                   
        }
        if(this.arr.leads) {
          this.kanban.blocks = []
          this.arr.leads.forEach(element => {
            this.kanban.blocks.push({
              id: element.id,
              status: element.status,
              title: element.name,
              data: element,
            })
          });          
        }
      },

      // ARCHIVE LEAD
      archiveLead(item) {
        let loader = this.$loading.show();        
        
        var result = serviceAPI.guardarCheckArchive({
          id: item.id
        });

        result.then((response) => {          
          loader.hide()

          this.filterQuery()

          var msj = ''
          if(item.archive) {
            msj = "RESTAURADO"
          } else {
            msj = "ARCHIVADO"
          }
          
          this.$awn.success("Datos guardados con éxito. " + msj);
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      
      // CONTACT CUSTOMERS
      openContactsCustomers(item) {        
        this.modal.contacts.active = true
        this.modal.contacts.title = "Contactos del Cliente"
        this.modal.contacts.customer = item.customer        
      },
      addComment(item) {
        let loader = this.$loading.show();     

        this.crud.formHistory.leads_id = item.id
        this.crud.formHistory.staff_id = Helper.getStaffId()        
        var result = serviceAPI.agregarHistoria(this.crud.formHistory);

        result.then((response) => {          
          loader.hide()

          this.filterQuery()
          
          this.crud.formHistory.leads_id = null
          this.crud.formHistory.staff_id = Helper.getStaffId()        
          this.crud.formHistory.comment = ''

          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {                             
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      removeComment(item) {
        this.confirmDialog('¿Borrar comentario?', { title: 'Borrar comentario', icon: 'delete', danger: true, okTitle: 'Sí', cancelTitle: 'No' })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarHistoria(item.id);

            result.then((response) => {                                  
              this.filterQuery()
              
              setTimeout(()=> {
                var _item = null
                if(this.table.items) {
                  this.table.items.forEach(element => {                  
                    if(element.id == item.leads_id) {                    
                      _item = element                    
                    }
                  });
                }
                this.openHistory(_item)

                loader.hide()
                
                this.$awn.success("Registro eliminado");
              },1000)                            
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      addCommentFromHistoryModal() {
        if(!this.modal.history.leads_id) {
          this.$awn.alert('No se encontró la oportunidad del historial');
          return;
        }

        const comment = this.modal.history.comment ? this.modal.history.comment.trim() : '';
        if(!comment) {
          this.$awn.alert('Debe ingresar un comentario');
          return;
        }

        let loader = this.$loading.show();
        var data = {
          leads_id: this.modal.history.leads_id,
          staff_id: Helper.getStaffId(),
          comment: comment,
        };
        var result = serviceAPI.agregarHistoria(data);

        result.then((response) => {
          this.modal.history.comment = '';
          this.filterQuery();

          setTimeout(() => {
            var _item = null;
            if(this.table.items) {
              this.table.items.forEach(element => {
                if(element.id == this.modal.history.leads_id) {
                  _item = element;
                }
              });
            }

            if(_item) {
              this.openHistory(_item);
            }

            loader.hide();
            this.$awn.success("Datos guardados con éxito");
          }, 1000);
        })
        .catch(error => {
          loader.hide();
          this.$awn.alert(Error.showError(error));
        })
      },
      previewPopoverHistory(item) {  
        let style = '<style>p, ul {margin-bottom: 5px !important;} hr {margin: 0px !important;}</style>'              
        var history = ''
        if(item.history) {
          
          var arrReverseHistory = [...item.history].reverse()

          arrReverseHistory.forEach((element, index) => {         
            if(arrReverseHistory.length - 1 != index) {
              history += moment(element.date).format('DD MMMM') + ' - ' + element.comment + '<hr>'
            } else {
              history += moment(element.date).format('DD MMMM') + ' - ' + element.comment
            }              
          });
        }
        return style + history
      },
      openHistory(item) {                
        if(!item)
          return;

        this.modal.history.active = true
        this.historyItem = item
        this.modal.history.title = "Historial de la Oportunidad"
        this.modal.history.leads_id = item.id
        this.modal.history.comment = ''

        this.tableHistory.items = item.history ? [...item.history] : []
      },

      // BUDGET
      sendPrinterBudget(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
      },

      // KANABN
      updateBlock(id, status) {    
        var obj = null
        this.arr.leads.forEach(element => {
          if(element.id == id) {
            obj = element
          }
        });    

        if(status != 'won' && status != 'lost') {
          if(this.validStatusAction(obj, status) == 'next'){
            this.nextStage(obj)               
            return true
          } 
          
          if(this.validStatusAction(obj, status) == 'prev'){
            this.previousStage(obj)               
            return true          
          }         

          this.$awn.alert("No puede realizar esta operación");
          this.kanban.forceUpdate = this.kanban.forceUpdate + 1
          this.loadSalesFlowKanban()        
        } 
        
        if(status == 'won' || status == 'lost') {
          this.crud.form.lost_motives_id = null
          this.modal.stage.value = status
          this.modal.stage.id = id
          this.modal.stage.date_status = obj && obj.date_status ? obj.date_status : this.getStageDefaultDate()

          this.modal.stage.title = "Etapa Final"
          this.modal.stage.active = true          
        }
      }, 
    }    
  }
</script>

<style>
  .crud-leads-services-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-leads-services-wizard .wizard-card-footer .wizard-footer-left,
  .crud-leads-services-wizard .wizard-card-footer .wizard-footer-right { float: none !important; }
  .crud-leads-services-wizard .wizard-card-footer .wizard-footer-right { margin-left: auto; }
  .crud-leads-services-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-leads-services-wizard .wizard-footer-left .wizard-btn::before,
  .crud-leads-services-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-leads-services-wizard .wizard-footer-left .wizard-btn::before { content: 'arrow_back'; margin-right: 6px; }
  .crud-leads-services-wizard .wizard-footer-right .wizard-btn::after { content: 'arrow_forward'; margin-left: 6px; }
  .crud-leads-services-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-leads-services-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-leads-services-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-leads-services-wizard .wizard-footer-right .wizard-btn:hover { filter: brightness(.94); }
  @media (max-width: 767.98px) {
    .crud-leads-services-wizard .wizard-card-footer { gap: 8px; padding: 12px 0 0; }
    .crud-leads-services-wizard .wizard-footer-left,
    .crud-leads-services-wizard .wizard-footer-right { display: flex; flex: 1 1 0; }
    .crud-leads-services-wizard .wizard-card-footer .wizard-footer-right { margin-left: 0; }
    .crud-leads-services-wizard .wizard-footer-left > span,
    .crud-leads-services-wizard .wizard-footer-right > span { display: block; width: 100%; }
    .crud-leads-services-wizard .wizard-btn { width: 100%; min-width: 0; }
  }
  .sales-flow-leads-services-table.app-table thead th,
  .sales-flow-leads-services-table.app-table tbody td { padding: 3px 8px !important; }
  .sales-flow-leads-services-table.app-table thead th:first-child,
  .sales-flow-leads-services-table.app-table tbody td:first-child { padding-left: 12px !important; }
  .sales-flow-leads-services-table.app-table thead th:last-child,
  .sales-flow-leads-services-table.app-table tbody td:last-child { padding-right: 12px !important; }
  .sales-flow-leads-services-table .app-table-action-toggle { width: 26px; height: 26px; }
  .btn.sales-flow-leads-services-action-toggle-labeled { display: inline-flex !important; align-items: center; justify-content: flex-start; width: auto !important; height: auto !important; min-height: 0; padding: 0 !important; border: none !important; background: transparent !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; font-size: 13px; line-height: 1.15; }
  .btn.sales-flow-leads-services-action-toggle-labeled:hover,
  .btn.sales-flow-leads-services-action-toggle-labeled:focus { color: var(--app-color-primary) !important; text-decoration: underline; }
  .sales-flow-leads-services-table-footer { min-height: 31px; margin-top: 0; padding: 0 12px 0 0; }
  @media (max-width: 767.98px) { .sales-flow-leads-services-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before { content: attr(data-label) !important; } }
  .sales-flow-lead-date { display: flex; flex-direction: column; line-height: 1.25; }
  .sales-flow-lead-date span { color: var(--app-color-text-muted); font-size: var(--app-text-xs); }
  .sales-flow-lead-contact { display: flex; align-items: center; gap: 5px; line-height: 1.7; }
  .sales-flow-lead-contact .app-icon { color: var(--app-color-text-muted); font-size: 15px; }
  .sales-flow-lead-info { display: flex; align-items: center; gap: 5px; line-height: 1.7; }
  .sales-flow-lead-info .app-icon { color: var(--app-color-text-muted); font-size: 15px; }
  .sales-flow-lead-budget { display: inline-block; }
  @media (max-width: 767.98px) { .sales-flow-lead-budget { display: inline-flex; align-items: center; gap: 5px; white-space: nowrap; } }
  .sales-flow-lead-status__reason { margin-top: 3px; color: var(--app-color-text-secondary); font-size: var(--app-text-xs); line-height: 1.3; white-space: normal; overflow-wrap: anywhere; }
  .sales-flow-lead-identity { border-left: 2px solid var(--app-color-primary-200); padding-left: 8px; }
  .sales-flow-lead-identity--interested { border-left-color: var(--app-color-primary); }
  .sales-flow-lead-identity--in.process { border-left-color: var(--app-color-warning); }
  .sales-flow-lead-identity--approval { border-left-color: darkmagenta; }
  .sales-flow-lead-identity--won { border-left-color: var(--app-color-success); }
  .sales-flow-lead-identity--lost { border-left-color: var(--app-color-danger); }
  .crud-leads-table-title-person,
  .crud-leads-table-title-company { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); letter-spacing: .04em; text-decoration: none; text-transform: uppercase; }
  .crud-leads-table-title { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); text-decoration: none; }
  .crud-leads-table-title-name { color: var(--app-color-text); font-size: var(--app-text-sm); }
  .sales-flow-lead-history-trigger { gap: 3px; width: auto !important; padding: 0 4px !important; }
  .sales-flow-history-list { display: flex; flex-direction: column; gap: 10px; }
  .sales-flow-history-entry { display: flex; align-items: flex-start; gap: 8px; padding: 10px; border: 1px solid var(--app-color-border); border-radius: 8px; background: var(--app-color-surface-subtle); }
  .sales-flow-history-entry__body { flex: 1; min-width: 0; white-space: pre-wrap; }
  .sales-flow-history-entry__meta { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 3px; color: var(--app-color-text-secondary); font-size: var(--app-text-xs); }
  .sales-flow-history-entry__meta strong { color: var(--app-color-text); }
  .sales-flow-kanban { padding: 12px; }
  .sales-flow-kanban-column-heading { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 10px 12px; color: var(--app-color-on-primary); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); }
  .sales-flow-kanban-column-heading .badge { background: rgba(255,255,255,.22); color: inherit; }
  .sales-flow-kanban-column-heading--interested { background: var(--app-color-primary); }
  .sales-flow-kanban-column-heading--in.process { background: var(--app-color-warning); color: var(--app-color-on-primary); }
  .sales-flow-kanban-column-heading--approval { background: darkmagenta; }
  .sales-flow-kanban-column-heading--won { background: var(--app-color-success); }
  .sales-flow-kanban-column-heading--lost { background: var(--app-color-danger); }
  .sales-flow-kanban-card { display: flex; flex-direction: column; gap: 10px; padding: 12px; border: 1px solid var(--app-color-border); border-radius: 10px; background: var(--app-color-surface); box-shadow: var(--app-shadow-sm); cursor: grab; }
  .sales-flow-kanban-card__header,
  .sales-flow-kanban-card__metrics,
  .sales-flow-kanban-card__people,
  .sales-flow-kanban-card__footer { display: flex; align-items: center; flex-wrap: wrap; gap: 7px; color: var(--app-color-text-secondary); font-size: var(--app-text-xs); }
  .sales-flow-kanban-card__header { justify-content: space-between; }
  .sales-flow-kanban-card__type { color: var(--app-color-primary); font-weight: var(--app-font-semibold); text-transform: uppercase; letter-spacing: .04em; }
  .sales-flow-kanban-card__title { color: var(--app-color-text); font-size: var(--app-text-md); line-height: 1.3; }
  .sales-flow-kanban-card__tags { display: flex; flex-wrap: wrap; gap: 5px; }
  .sales-flow-kanban-card__tags span { display: inline-flex; align-items: center; gap: 3px; padding: 3px 6px; border-radius: 999px; background: var(--app-color-surface-subtle); color: var(--app-color-text-secondary); font-size: var(--app-text-xs); }
  .sales-flow-kanban-card__people > span { display: inline-flex; align-items: center; gap: 5px; }
  .sales-flow-kanban-card__footer { padding-top: 9px; border-top: 1px solid var(--app-color-border); }

  .crud-leads-select { background: var(--app-color-surface); }
  .crud-leads-table-title-status {        
    font-weight: 700;    
  }
  .crud-leads-table-title-status--interested { color: var(--app-color-primary); }
  .crud-leads-table-title-status--in.process { color: var(--app-color-warning-hover); }
  .crud-leads-table-title-status--approval { color: darkmagenta; }
  .crud-leads-table-title-status--won { color: var(--app-color-success-hover); }
  .crud-leads-table-title-status--lost { color: var(--app-color-danger-hover); }
  .crud-leads-title-attachment {
    font-size: 17px;
  }
  .crud-lead-print-icon {
    color: #000 !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 18px;
  }  
  .crud-lead-rocket-icon {
    color: #000 !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 18px;
  }    
  .crud-leads-preview-contract {
    background: #e5e5e5;    
    padding: 15px;
    height: 450px;        
  }

  .crud-leads-preview-contract .crud-leads-preview-contract-alert {
    background: #fff;        
  }
  .crud-leads-preview-contract .crud-leads-preview-contract-html {
    background: #fff;
    height: 450px;     
    padding: 15px;   
    overflow: overlay;
  }  
  .crud-leads-preview-open-pdf {
    margin-top: 10px;
  }
  .sales-flow-leads-image .image-container{
    width: 100%
  }

  .crud-lead-kanban-create {
    color: black;
    font-size: 10px;
    margin-top: 5px;
  }
  .crud-lead-kanban-create:hover {
    font-weight: bold;
    color: black;
    font-size: 10px;    
  }

  .crud-lead-kanban-unassign {
    color: darkred;
    font-size: 10px;
    margin-top: 5px;
  }
  .crud-lead-kanban-unassign:hover {
    font-weight: bold;
    color: darkred;
    font-size: 10px;
  }  
</style>

<style>
  .drag-column-interested {
    background: var(--app-color-primary-soft);
    color: var(--app-color-text);
  }
  .drag-column-in {
    background: var(--app-color-warning-soft);
    color: var(--app-color-text);
  }
  .drag-column-approval {
    background: rgba(139, 0, 139, .10);
    color: var(--app-color-text);
  }    
  .drag-column-won {
    background: var(--app-color-success-soft);
    color: var(--app-color-text);
  }    
  .drag-column-lost {
    background: var(--app-color-danger-soft);
    color: var(--app-color-text);
  }        
  .drag-item{  
    background: transparent;
  }
  .sales-flow-kanban-date {
    position: absolute;
    right: 20px;
  }
  .sales-flow-kanban-hr {
    margin-top: 5px;
    margin-bottom: 5px;
    border: 0;
    border-top: 1px solid rgb(255 255 255);
  }
  .crud-leads-history-preview-popover {
    pointer-events: none;
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>
